import { EmojiNodeSpec, EMOJI_KEY } from '@techchange/pm-specs';

import EmojiButton from './components/EmojiButton';
import emojiViewPlugin from './plugins/emojiView';

const emoji = {

	nodes() {

		return {
			[EMOJI_KEY]: EmojiNodeSpec,
		};

	},

	plugins(options) {

		return [emojiViewPlugin(options.emojiSize)];

	},

	toolbarButtons() {

		return [{ Button: EmojiButton, key: 'EmojiButton' }];

	},

};

export default emoji;
